// removed by extract-text-webpack-plugin
module.exports = {"component-wrapper":"styles__component-wrapper___H3YHG","component-title":"styles__component-title___2YEhx","occurences-table":"styles__occurences-table___2oGOb","table-header":"styles__table-header___11LLX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ReportComponents/Tables/HistoryTable/styles.scss
// module id = 7078
// module chunks = 0